<template>
  <div class="green-bend">
    <div class="green-inside grid grid-cols-1 lg:grid-cols-5">
      <div class="col-span-2 yardology">
        <img loading="lazy"
          v-if="pageData.section_3_image && pageData.section_3_image.url"
          :src="imageLocation + pageData.section_3_image.url" 
          :alt="pageData.section_3_image.alt"
          class="hidden lg:inline-block"
          style="width:100%"
        />
        <div class="yardology-text">
          <h2 class="text-white" v-html="pageData.section_3_title"></h2>
          <h3 class="text-white" v-html="pageData.section_3_text"></h3>
        </div>
      </div>
      <div
        class="
          col-span-3
          bg-white
          round-top-right
          round-bottom-right
          lg:p-12
          carousel
          overflow-hidden
          yardology-carousel
        "
        v-if="guides"
      >
        <GuidesCarousel :guides="guides" :vertical="true" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import {useNuxtApp} from '#app';

const {$config, $sg} = useNuxtApp();

// Define props
const props = defineProps<{
  pageData: {
    connected_guides_type: string;
    connected_lawn_care_guides: any;
    connected_pest_control_guides: any;
    connected_tree_care_guides: any;
  }
}>();

const imageLocation = ref($config.public.sgCmsImage);
const guides = ref<any>(undefined);

onMounted(async () => {
  guides.value = await $sg.getConnectedGuides(
    props.pageData.connected_guides_type,
    props.pageData.connected_lawn_care_guides,
    props.pageData.connected_pest_control_guides,
    props.pageData.connected_tree_care_guides
  );
});
</script>

<style scoped>
.green-inside {
  width: 90%;
  text-align: center;
  margin-left: 5%;
  padding-top: 40px;
  padding-bottom: 40px;
}

.green-inside h2 {
  font-size: 3em;
  font-weight: 400;
  margin-bottom: 20px;
}

.yardology {
  position: relative;
}

.yardology img {
  border-top-left-radius: 45px;
  border-bottom-left-radius: 45px;
  height: 100%;
  object-fit: cover;
}

.yardology-text {
  position: absolute;
  left: 0;
  top: 60px;
  width: 100%;
}

.round-top-right {
  border-top-right-radius: 70px;
}

.round-bottom-right {
  border-bottom-right-radius: 70px;
}

@media (max-width: 1280px) {
  .yardology-text {
    margin-bottom: 40px;
  }

  .green-bend {
    height: unset;
    margin-bottom: 40px;
  }

  .green-inside {
    position: relative;
    left: unset;
    top: unset;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

@media (max-width: 768px) {
  .yardology-text {
    position: unset;
  }
  
  .yardology-carousel {
    border-radius: 70px;
  }
}

</style>
